export default __webpack_public_path__ + "static/media/red-pay-logo.07577d25.png";